<template>
  <div
    v-if="settingResponedFlag"
    class="index-container"
    :style="`backgroundColor: ${activitySetting.bodyColor || '#2C1C47'}`"
  >
    <div class="top-banner-wrapper">
      <div
        class="img-wrapper"
        :style="{
          aspectRatio: `${activitySetting.topBannerWHRadio || '75/107'}`,
        }"
      >
        <img
          :src="
            activitySetting.topBanner ||
              `//x.autoimg.cn/cfw/cfw/activity/guessing-competition/top-kv.png?t=${new Date().getTime()}`
          "
          alt=""
        />
        <div
          class="activity-time-wrapper"
          v-if="activityInfo.startDate && activityInfo.endDate"
          :style="{
            top: `${activitySetting.timeDistanceTop || '17'}px`,
            background: `url(${activitySetting.activityTimeBg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/activity-time-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
          }"
        >
          <span
            >{{
              activityInfo.startDate
                .replace(/-/g, ".")
                .slice(5, activityInfo.startDate.length - 9)
            }}
            -
            {{
              activityInfo.endDate
                .replace(/-/g, ".")
                .slice(5, activityInfo.endDate.length - 9)
            }}</span
          >
        </div>
      </div>
      <!-- 活动规则 && 分享按钮 -->
      <div
        class="rules-share-btn-wrapper"
        :style="{
          top: `${activitySetting.shareBtnTopDistance || '190px'}`,
        }"
      >
        <div
          class="btn"
          :style="{
            backgroundImage: `${activitySetting.ruleShareBgImg ||
              'linear-gradient(270deg, #FF7ECC 0%, #FF27A9 100%)'}`,
            backgroundColor: `${activitySetting.ruleShareBgColor}`,
            color: `${activitySetting.ruleShareColor || '#fff'}`,
          }"
          @click.stop="viewRules()"
        >
          活动规则
        </div>
        <div
          class="btn share-btn"
          :style="{
            backgroundImage: `${activitySetting.ruleShareBgColor ||
              'linear-gradient(270deg, #FF7ECC 0%, #FF27A9 100%)'}`,
            color: `${activitySetting.ruleShareColor || '#fff'}`,
          }"
          v-if="isAutohomeApp || isWzApp"
          @click.stop="setWeiXinShare(true, 'pagetips')"
        >
          <span class="share-icon"></span> 分享
        </div>
      </div>
    </div>
    <div
      class="main-container"
      :style="`marginTop: ${activitySetting.mainTopDistance}`"
    >
      <!-- 定损价格竞猜 -->
      <div class="loss-assessment-container">
        <!-- 顶部banner背景多余部分 -->
        <!-- <div
          class="top-banner-bg"
          :style="{
            'background': `url(${activitySetting.topBanner2 || '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/loss-assessment-bg1.png'}) no-repeat`,
            'backgroundSize': '100% 100%'
          }"
        ></div> -->
        <div
          class="loss-assessment-wrapper"
          :style="{
            background: `url(${activitySetting.lossAssessmentBg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/activity-banner-bg.png?t=1'}) no-repeat`,
            backgroundSize: '100% 100%',
          }"
        >
          <div
            class="common-module-title loss-assessment-title"
            :style="{
              background: `url(${activitySetting.commontitlebg2 ||
                '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg2.png?t=1'}) no-repeat`,
              backgroundSize: '100% 100%',
              marginTop: `${-topBanner2Height}px`,
              color: `${activitySetting.commonTitleColor || '#fff'}`,
            }"
          >
            {{ activitySetting.activityName }}
          </div>
          <!-- banner轮播 -->
          <div
            class="banner-list-wrapper"
            v-if="
              activitySetting.bannersList &&
                JSON.parse(activitySetting.bannersList).length
            "
          >
            <div class="banenr-swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-show="activitySetting.bannerVideo">
                  <div id="video-wrapper"></div>
                  <div
                    class="mask"
                    @click="videoPlayHandel"
                    v-show="videoMaskShow && !isWzAndroid"
                  ></div>
                </div>
                <div
                  class="swiper-slide"
                  v-for="(item, index) in JSON.parse(
                    activitySetting.bannersList
                  )"
                  :key="index"
                >
                  <img :src="item" alt="" />
                </div>
              </div>
              <!-- swiper 页标 -->
              <div class="swiper-number-wrapper" v-show="swiperActiveIndex">
                <span
                  class="active"
                  :style="
                    `color: ${activitySetting.bannerBulletColor || '#F5293F'}`
                  "
                  >{{ swiperActiveIndex + 1 }}</span
                >
                <span>/</span>
                <span>{{
                  (activitySetting.bannersList &&
                    JSON.parse(activitySetting.bannersList).length) +
                    (activitySetting.bannerVideo ? 1 : 0)
                }}</span>
              </div>
            </div>
          </div>
          <!-- 分页器 -->
          <div
            class="my-swiper-pagination"
            v-if="
              activitySetting.bannersList &&
                JSON.parse(activitySetting.bannersList).length
            "
          >
            <span
              class="my-swiper-pagination-bullet"
              :class="{ active: swiperActiveIndex === index }"
              :style="{
                backgroundColor: `${activitySetting.bannerBulletColor ||
                  '#2C1C47'}`,
              }"
              v-for="(item, index) in JSON.parse(activitySetting.bannersList)
                .length + (activitySetting.bannerVideo ? 1 : 0)"
              :key="index"
            ></span>
          </div>
        </div>
      </div>
      <!-- 已参与用户头像列表 -->
      <ul
        class="involved-portrait-list"
        :style="{
          background: `url(${activitySetting.userPortraitListBg ||
            '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/user-portrait-list-bg.png?t=1'}) no-repeat`,
          backgroundSize: '100% 100%',
        }"
        v-if="headImgList.length"
      >
        <p class="list-title">已有{{ count }}人参与活动</p>
        <li
          class="user-portrait"
          v-for="(item, index) in headImgList.slice(0, 7)"
          :key="index"
          v-show="index < 7"
        >
          <img :src="item.headImg" alt="" />
        </li>
        <li
          class="user-portrait user-portrait-last"
          v-if="headImgList.slice(0, 7).length === 7"
        ></li>
      </ul>
      <!-- 中奖结果入口 -->
      <div
        class="award-entry-wrapper"
        @click.stop="linkResultPage('awardEntry')"
      >
        <img
          :src="
            activitySetting.awardEntryIcon ||
              `//x.autoimg.cn/cfw/cfw/activity/guessing-competition/award-entry-icon.png?t=${new Date().getTime()}`
          "
          alt=""
        />
      </div>
      <!-- 本期奖品 -->
      <div class="prize-issue-wrapper" v-if="prizeList.length">
        <div
          class="common-module-title"
          :class="{ 'headImg-list-none': headImgList.length }"
          :style="{
            background: `url(${activitySetting.commontitlebg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
            color: `${activitySetting.commonTitleColor || '#fff'}`,
          }"
        >
          本期奖品
        </div>
        <div
          class="common-container"
          :style="{
            backgroundImage: `linear-gradient(270deg, ${activitySetting.commonContainerColorLeft ||
              '#FFD297'} 100%, ${activitySetting.commonContainerColorRight ||
              '#FFD297'} 100%)`,
            backgroundColor: `${activitySetting.commonContainerColor ||
              '#FFD297'}`,
          }"
          @click.stop="viewAwardDetail(prizeList[0].useUrl)"
        >
          <div
            class="prize-wrapper"
            :style="
              `backgroundColor: ${activitySetting.commonWrapperColor || '#fff'}`
            "
          >
            <img v-lazy="prizeList[0].prizeImg" alt="奖品的图片" />
          </div>
        </div>
      </div>
      <!-- 活动说明 -->
      <div class="activity-instructions-wrapper">
        <div
          class="common-module-title"
          :style="{
            background: `url(${activitySetting.commontitlebg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
            color: `${activitySetting.commonTitleColor || '#fff'}`,
          }"
        >
          活动说明
        </div>
        <div
          class="common-container"
          :style="{
            backgroundImage: `linear-gradient(270deg, ${activitySetting.commonContainerColorLeft ||
              '#FFD297'} 100%, ${activitySetting.commonContainerColorRight ||
              '#FFD297'} 100%)`,
            backgroundColor: `${activitySetting.commonContainerColor ||
              '#FFD297'}`,
          }"
        >
          <div
            class="text-wrapper"
            :style="
              `backgroundColor: ${activitySetting.commonWrapperColor || '#fff'}`
            "
          >
            <!-- <p class="text">根据本期车辆受损照片猜测车辆4S店维修价格。<span class="hight-light">最先回答且价格最接近者</span>，即可获得1000元无忧车主礼包。</p> -->
            <p
              class="text"
              v-html="
                activitySetting.activityDescription &&
                  activitySetting.activityDescription.replace(/\r\n/g, '<br/>')
              "
            ></p>
            <p
              class="time-wrapper"
              v-if="activitySetting.prizeOpenTime"
              :style="{
                background: `url(${activitySetting.timeWrapperBg ||
                  '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/time-wrapper-bg.png'}) no-repeat`,
                backgroundSize: '100% 100%',
                color: `${activitySetting.timeWrapperColor} || '#111E36'`,
              }"
            >
              答案公布时间：{{
                activitySetting.prizeOpenTime.slice(
                  0,
                  activitySetting.prizeOpenTime.length - 3
                )
              }}
            </p>
          </div>
        </div>
      </div>
      <!-- 竞猜价格 -->
      <div class="price-wrapper" v-if="guessList.length">
        <div
          class="common-module-title"
          :style="{
            background: `url(${activitySetting.commontitlebg ||
              '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/common-title-bg.png'}) no-repeat`,
            backgroundSize: '100% 100%',
            color: `${activitySetting.commonTitleColor || '#fff'}`,
          }"
        >
          竞猜价格
        </div>
        <div
          class="common-container price-scroll-box"
          :style="{
            backgroundImage: `linear-gradient(270deg, ${activitySetting.commonContainerColorLeft ||
              '#FFD297'} 100%, ${activitySetting.commonContainerColorRight ||
              '#FFD297'} 100%)`,
            backgroundColor: `${activitySetting.commonContainerColor ||
              '#FFD297'}`,
          }"
        >
          <div
            class="price-list-wrapper"
            ref="viewBox"
            :style="
              `backgroundColor: ${activitySetting.commonWrapperColor || '#fff'}`
            "
          >
            <ul class="price-list">
              <li v-for="(item, index) in guessList" :key="index">
                <div class="left">
                  <img :src="item.autouserheaderimg" alt="" class="head-img" />
                  <img
                    src="../assets/images/crown-icon.png"
                    alt=""
                    class="crown-icon"
                    v-if="item.prized === 1"
                  />
                </div>
                <div class="middle">
                  <div class="middle-top">
                    <span class="name">{{ item.autousername }}</span
                    ><span class="time">{{ item.createdStimeText }}</span>
                    <span
                      class="luck-boy"
                      v-if="item.prized === 1 && !item.prizeLevel"
                    ></span>
                    <span
                      v-if="
                        item.prizeLevel === 1 ||
                          item.prizeLevel === 2 ||
                          item.prizeLevel === 3 ||
                          item.prizeLevel === 10 ||
                          item.prizeLevel === 30
                      "
                      class="price-lebel"
                      :class="{
                        'level-1': item.prizeLevel === 1,
                        'level-2': item.prizeLevel === 2,
                        'level-3': item.prizeLevel === 3,
                        'level-10': item.prizeLevel === 10,
                        'level-30': item.prizeLevel === 30,
                      }"
                    ></span>
                  </div>
                  <div class="middle-bottom">
                    <span>竞猜价格：</span><span>{{ item.price }}元</span>
                  </div>
                </div>
                <!-- <div class="right" @click.stop="likeClick(item, index)">
                  <div class="like-btn">
                    <img src="../assets/images/like.png" alt="" v-if="item.liked === 0">
                    <img src="../assets/images/like-active.gif" alt="" v-else-if="likeClicked && (likeClickIndex === index)">
                    <img src="../assets/images/like-active.png" alt="" v-else>
                  </div>
                  <div class="like-amount" @click.stop>{{ item.likeCount < 99 ? item.likeCount : '99+' }}</div>
                </div> -->
              </li>
              <li v-if="guessList.length > 4" class="load-more-tips">
                {{ loadMoreText }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="bottom-btn-wrapper" @click.stop="bottomBtnClick">
      <div
        v-if="bottomBtnShow"
        class="bottom-btn"
        :style="{
          background: `url(${activitySetting.bottomBtnBg ||
            '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/bottom-btn-bg.png'}) no-repeat`,
          backgroundSize: '100% 100%',
          color: `${activitySetting.bottomTextColor || '#740700'}`,
        }"
      >
        {{ btnText }}
      </div>
    </div>
    <!-- 竞猜价格弹窗 -->
    <transition name="fade">
      <div
        class="price-dialog-container"
        v-show="dialogShow"
        @click.stop="closeDialog"
      >
        <div class="price-dialog-wrapper" @click.stop>
          <div class="title-icon">
            <img
              :src="
                activitySetting.dialogTitleIcon ||
                  '//x.autoimg.cn/cfw/cfw/activity/guessing-competition/dialog-title-icon.png'
              "
              alt=""
            />
          </div>
          <div class="title">竞猜价格(元)</div>
          <div class="input-wrapper" @click="inputClick">
            <input
              type="text"
              inputmode="decimal"
              step="0.01"
              placeholder="请输入竞猜价格"
              v-model="inputPrice"
              @input="inputChangeHandel($event)"
              @blur="onBlur"
            />
          </div>
          <div
            class="confirm-btn"
            :class="{ disable: !inputPrice }"
            :style="{
              backgroundColor: `${activitySetting.confirmBtnBgColor ||
                '#3E52E6'}`,
              color: `${activitySetting.confirmBtnColor || '#FFF'}`,
            }"
            @click.stop="confirmHandel"
          >
            确定
          </div>
          <div class="close-icon-wrapper" @click.stop="closeDialog">
            <div class="close-icon"></div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 活动规则弹窗 -->
    <transition name="fade">
      <div
        class="rules-bg-wrapper"
        v-show="ruleTextShow"
        @click.stop="ruleTextShow = !ruleTextShow"
      >
        <div class="rules-wrapper" @click.stop>
          <div class="title">活动规则</div>
          <div
            class="content"
            v-html="
              activitySetting.activityRule &&
                activitySetting.activityRule.replace(/\r\n/g, '<br/>')
            "
          ></div>
          <div
            class="close-icon-wrapper"
            @click.stop="ruleTextShow = !ruleTextShow"
          >
            <div class="close-icon"></div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 大图预览控件 -->
    <van-image-preview
      v-model="bigImageShow"
      :images="JSON.parse(activitySetting.bannersList)"
      :start-position="startIndex"
      :loop="true"
      @change="onChange"
    >
      <template v-slot:index
        >{{ activeIndex }}/{{
          JSON.parse(activitySetting.bannersList) &&
            JSON.parse(activitySetting.bannersList).length
        }}</template
      >
    </van-image-preview>
    <!-- 未登录遮罩提示 -->
    <div class="unlogin-mask" @click.stop="loginHandel" v-if="!isLogin"></div>
    <!-- 竞猜后弹窗 -->
    <confirm
      :confirmDialogShow="confirmDialogShow"
      :activitySetting="activitySetting"
      :guessPrice="Number(guessPrice)"
      :resultMsg="guessResultMsg"
      @on-left-click="onLeftClick"
      @on-right-click="onRightClick"
      @on-close="onCloseHandel"
    />
  </div>
</template>
<script>
import Api from "../api";
import * as Common from "../tool/common";
import * as Tool from "../tool";
import * as Utils from "../tool/utils";

import Player from "xgplayer/dist/simple_player";
import volume from "xgplayer/dist/controls/volume";
import Swiper from "swiper/dist/js/swiper.js";
import "swiper/dist/css/swiper.min.css";
import { ImagePreview, Dialog } from "vant";
import confirm from "../components/confirm.vue";

export default {
  name: "Index",
  data() {
    return {
      type: "",
      isLogin: false,
      activitySetting: {}, // 活动模板设置
      activityInfo: {}, // 活动信息
      headImgList: [], // 参与用户头像列表
      guessList: [], // 参与用户list
      count: "", // 参与竞猜人数
      settingResponedFlag: false, // 活动配置是否返回数据
      topBanner2Height: 0,
      swiperActiveIndex: 0,
      dialogShow: false, // 输入价格弹层
      inputPrice: "", // 用户输入的价格
      guessPrice: "",
      lastId: 0, // 竞猜列表最后一项id
      hasMore: true, // 分页加载更多参数
      ruleTextShow: false, // 活动规则弹窗显示
      isAutohomeApp: Tool.webApp.checkAutoHomeApp(),
      isWzApp: Tool.webApp.checkViolatApp(),
      isWzAndroid: Tool.webApp.wzAndroid(),
      activityCode: Tool.getUrlParam().code || "",
      userGuessed: "", // 用户参与活动状态
      prizeList: [], // 奖品
      btnTextStatus: "", // 0: 活动尚未开始，立即添加提醒  1:立即参与   2:您已参与，等待开奖结果   3:活动已结束，请查看开奖时间   4：活动已结束，查看更多活动
      likeClicked: false,
      likeClickIndex: 0, // 点赞的当前索引
      bigImageShow: false, // 大图预览组件
      activeIndex: 0, // 轮播组件点击的索引
      startIndex: 0,
      loadMoreText: "努力加载中...",
      player: null,
      confirmDialogShow: false,
      guessResultMsg: "",
      videoMaskShow: false,
      bottomBtnShow: false,
    };
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Dialog.Component.name]: Dialog.Component,
    confirm,
  },
  watch: {
    dialogShow(val) {
      document.documentElement.style.overflow = val ? "hidden" : "";
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(vm);
    });
  },
  computed: {
    btnText() {
      switch (
        this.btnTextStatus // 0: 活动尚未开始，立即添加提醒  1:立即参与   2:您已参与，等待开奖结果   3:活动已结束，请查看开奖时间   4：活动已结束，查看更多活动
      ) {
        case 0:
          return "活动尚未开始，立即添加提醒";
        case 1:
          return "立即参与";
        case 2:
          return "您已参与，分享最多可获得5次竞猜机会";
        case 3:
          return "活动已结束，请查看开奖时间";
        case 4:
          return "您已参与，等待开奖结果";
        case 5:
          return "活动已结束，请查看本期开奖结果";
        case 6:
          return "您已参与，今日竞猜机会已用完";
      }
    },
  },
  created() {
    this.guessList = [];
    this.getActivitySetting("init");
    this.getUserList(1);
    this.getLoginState();
  },
  methods: {
    pvReport(site_id, category_id, sub_category_id) {
      // pv 埋点
      Common.trackCustomPageInit(
        {
          site_id: site_id || 40,
          category_id: category_id || 1894,
          sub_category_id: sub_category_id || 22930,
          appKey: Tool.getCookie("app_key") || "h5",
          province: "",
          city: Tool.getCookie("app_cityid") || 110100,
          action: "cbz_yjjc_index_pv",
        },
        {
          pvareaid: Tool.getUrlParam().pvareaid || "",
          userId: Tool.getCookie("app_userid") || "",
          refpage_feed: Tool.getUrlParam().refpage || "",
          is_auto: Tool.webApp.uaIsAutohome() ? 1 : 0,
        }
      );
    },
    // 获取用户登录状态
    getLoginState() {
      Api.getIsLogin({})
        .then((res) => {
          if (res.returncode === 0) {
            this.isLogin = !!res.result.isLogin;
            if (this.isLogin) {
              // 已登录获取一次竞猜机会
              this.addActivityQualification("login");
            } else {
              this.bottomBtnShow = true;
            }
          } else {
            this.bottomBtnShow = true;
            this.loginHandel();
          }
        })
        .catch(() => {
          this.bottomBtnShow = true;
          this.$toast("当前无网络，请稍后重试");
        });
    },
    // 获取机会
    addActivityQualification(handelType) {
      // handelType: 'login':登录  'share':分享
      Api.addActivityQualificationByLoginUser({
        code: this.activityCode || Tool.getUrlParam().code || "",
        actionCode:
          handelType === "login"
            ? "open_d895bc4a1a72"
            : "fenxiang_223e7e2fe5a9",
      }).then((res) => {
        this.bottomBtnShow = true;
        if (res.returncode === 0) {
          let msg =
            handelType === "login"
              ? "登录成功，您已获得1次竞猜机会"
              : "分享成功，您已获得1次竞猜机会";
          if (handelType === "login") {
            this.$toast(msg);
          } else {
            setTimeout(() => {
              this.$toast(msg);
              this.getActivitySetting("reload");
            }, 2000);
          }
        } else if (res.returncode === 2 && handelType === "share") {
          this.btnTextStatus = 6;
          setTimeout(() => {
            this.$toast("今日竞猜机会已达上限，明日再接再厉");
          }, 2000);
        }
      });
    },
    onLeftClick() {
      this.handleTrackCustomEvent(
        "cbz_yjjc_index_iknow",
        "cbz_yjjc_index_iknow_click"
      );
      this.confirmDialogShow = false;
    },
    onRightClick() {
      this.setWeiXinShare(true, "guessover");
    },
    onCloseHandel() {
      this.confirmDialogShow = false;
    },
    loginHandel() {
      if (!this.isLogin) {
        Dialog.confirm({
          message: "未登录，请先登录",
          className: "confirm-model",
          confirmButtonText: "登录",
        })
          .then(() => {
            // confirm -- 去登陆
            Common.handleLogin({
              successCb: () => {
                window.location.reload();
              },
              failCb: (error) => {
                console.log(error, "登录失败");
              },
            });
          })
          .catch(() => {
            // cancel
          });
      }
    },
    // 获取活动配置
    async getActivitySetting(type) {
      let code = this.activityCode || Tool.getUrlParam().code || "";
      window.localStorage.setItem("activityCode", code);
      try {
        let res = await Api.getActivitySetting({
          code,
        });
        if (res.returncode === 0) {
          let that = this;
          this.settingResponedFlag = true;
          this.activitySetting = { ...res.result.activitySetting };
          this.activityInfo = { ...res.result.activity };
          this.userGuessed = res.result.userGuessed;
          this.prizeList = [...res.result.prizeList];
          // pv
          if (type === "init" && this.activitySetting) {
            let {
              home_site_id,
              home_category_id,
              home_sub_category_id,
            } = this.activitySetting;
            this.pvReport(home_site_id, home_category_id, home_sub_category_id);
          }
          // 设置页面title
          Tool.setTitle(this.activitySetting.pageName || "");
          // 奖品信息存储本地 -- 结果页要用
          window.localStorage.setItem(
            "prizeList",
            JSON.stringify(this.prizeList)
          );
          window.localStorage.setItem(
            "activitySettingObj",
            JSON.stringify(this.activitySetting)
          );
          // 当前活动的状态
          switch (Number(this.activityInfo.status)) {
            case 0:
              this.btnTextStatus = 0;
              break;
            case 1:
              if (this.userGuessed === 0) {
                // 用户未参与
                this.btnTextStatus = 1;
              } else if (this.userGuessed === 1) {
                // 用户已参与
                this.btnTextStatus = 2;
              } else if (this.userGuessed === 2) {
                // 所有机会加一起 已到达上线且已用完
                this.btnTextStatus = 6;
              }
              break;
            case 2:
              if (this.userGuessed === 0) {
                // 用户未参与
                this.btnTextStatus = 3;
              } else if (this.userGuessed === 1) {
                // 用户已参与
                this.btnTextStatus = 4;
              } else if (this.userGuessed === 2) {
                // 机会已用完
                this.btnTextStatus = 4;
              }
              break;
            case 3:
              this.btnTextStatus = 5;
              break;
          }
          this.$nextTick(() => {
            this.topBanner2Height =
              document.querySelector(".top-banner-bg") &&
              document.querySelector(".top-banner-bg").clientHeight;
            // 初始化swiper
            new Swiper(".banenr-swiper-container", {
              // loop: this.activitySetting.bannersList && JSON.parse(this.activitySetting.bannersList).length > 1 ? true : false,
              loop: false,
              // autoplay: {
              //   disableOnInteraction: false
              // },
              observer: true,
              observeParents: true,
              on: {
                transitionStart: function() {
                  that.swiperActiveIndex = this.realIndex;
                },
                click: function() {
                  this.realIndex && that.viewBigImage(this.realIndex);
                },
                slideChangeTransitionEnd: function() {
                  if (this.realIndex) {
                    if (!that.player.paused) {
                      that.player.pause();
                    }
                  } else {
                    that.player.play();
                  }
                },
              },
            });
            type === "init" &&
              this.initVideoHandel(this.activitySetting.bannerVideo);
          });
          // 微信二次分享
          this.setWeiXinShare();
        } else {
          Dialog({ message: res.message });
          console.log("活动配置异常-----");
        }
      } catch (error) {
        this.$toast("当前无网络，请稍后重试");
        console.log(error, "获取活动配置接口异常信息");
      }
    },
    videoPlayHandel() {
      this.player.getFullscreen(this.player.root);
      if (this.player.paused) {
        this.player.play();
      }
    },
    // 视频初始化
    initVideoHandel(url) {
      let that = this;
      this.player = new Player({
        id: "video-wrapper",
        url,
        poster: this.activitySetting.bannerVideoPoster || "",
        // width: 327,
        // height: 182,
        autoplay: true,
        muted: true,
        fluid: true,
        playsinline: true,
        closeVideoPreventDefault: true,
        closeVideoStopPropagation: true,
        "x5-video-player-type": "h5",
        "x5-video-player-fullscreen": false,
        "x5-video-orientation": "portraint",
        ignores: this.isWzAndroid ? ["fullscreen", "replay"] : ["replay"],
        controlPlugins: [volume],
      });
      this.player.once("ready", () => {
        that.player.start(that.activitySetting.bannerVideo);
      });
      this.$nextTick(() => {
        that.player.once("complete", () => {
          try {
            setTimeout(() => {
              // 500毫秒收检测
              if (!that.player.hasStart && that.player.currentTime === 0) {
                // hasStart返回false，并且播放时间还是0，那么就可以认为自动播放失效了
                that.player.play();
              }
            }, 1000);
          } catch (e) {
            console.log(e, "---------------");
          }
        });
      });
      this.player.on("play", () => {
        if (!that.player.fullscreen && !that.player.paused) {
          that.videoMaskShow = true;
        }
      });
      this.player.on("ended", () => {
        that.videoMaskShow = false;
      });
      this.player.on("exitFullscreen", () => {
        setTimeout(() => {
          that.player.play();
        }, 1000);
      });
      this.player.on("controlShow", () => {
        document.querySelector(".mask").style.bottom = "50px";
      });
      this.player.on("controlHide", () => {
        document.querySelector(".mask").style.bottom = "0px";
      });
    },
    // 获取竞猜列表
    async getUserList(type) {
      // type: 1  首页加载
      try {
        if (!this.hasMore) {
          return;
        }
        let res = await Api.getUserList({
          code: this.activityCode || Tool.getUrlParam().code || "",
          size: 20,
          lastId: this.lastId,
        });
        if (res.returncode === 0) {
          if (res.result) {
            let that = this;
            this.count = res.result.count;
            this.headImgList = [...res.result.userList];
            if (res.result.guessList && res.result.guessList.length) {
              this.guessList = this.guessList.concat(res.result.guessList);
              let length = res.result.guessList.length;
              if (length < 20) {
                this.loadMoreText = "没有更多了";
              }
              this.lastId = res.result.guessList[length - 1].id;
              if (type === 1) {
                that.$nextTick(() => {
                  that.$refs.viewBox &&
                    that.$refs.viewBox.addEventListener(
                      "scroll",
                      () => {
                        let nowScotop =
                          window.innerHeight ||
                          document.documentElement.clientHeight; //可视区高度
                        let lastEle =
                          this.guessList.length &&
                          document
                            .querySelectorAll(".price-list > li")
                            [this.guessList.length - 1].getBoundingClientRect()
                            .bottom; // 最有一个元素的底部距离
                        if (nowScotop >= lastEle + 40) {
                          let t = that.throttle(that.getUserList, 300);
                          t();
                        }
                      },
                      true
                    );
                });
              }
            } else {
              this.hasMore = false;
              this.loadMoreText = "没有更多了";
            }
          }
        }
      } catch (error) {
        this.$toast("当前无网络，请稍后重试");
        console.log(error, "获取竞猜列表异常------");
      }
    },
    // 底部按钮点击
    bottomBtnClick() {
      // 0: 活动尚未开始，立即添加提醒  1:立即参与   2:您已参与，等待开奖结果   3:活动已结束，请查看开奖时间   4：活动已结束，查看更多活动
      if (this.btnTextStatus === 1) {
        // 未参与
        this.dialogShow = !this.dialogShow;
        this.handleTrackCustomEvent(
          "cbz_yjjc_index_cy",
          "cbz_yjjc_index_cy_click"
        );
      } else if (this.btnTextStatus === 0) {
        // 未开始  添加提醒
        this.handleTrackCustomEvent(
          "cbz_yjjc_index_tx",
          "cbz_yjjc_index_tx_click"
        );
        Api.getRemindMe({
          code: this.activityCode || Tool.getUrlParam().code || "",
        })
          .then((res) => {
            this.$toast(res.message);
          })
          .catch((error) => {
            this.$toast("当前无网络，请稍后重试");
            console.log(error, "添加提醒接口报错----");
          });
      } else if (this.btnTextStatus === 6) {
        // 您已参与，等待开奖结果
        this.handleTrackCustomEvent(
          "cbz_yjjc_index_ddkj",
          "cbz_yjjc_index_ddkj_click"
        );
        this.$toast(
          `感谢您的参与！敬请期待开奖结果, 开奖时间：${this.activitySetting.prizeOpenTime.slice(
            0,
            this.activitySetting.prizeOpenTime.length - 3
          )}`
        );
      } else if (this.btnTextStatus === 2) {
        // 分享得机会
        this.setWeiXinShare(true);
      }
      // 活动已结束 跳转中奖结果页
      if (this.activityInfo.status === 2 || this.activityInfo.status === 3) {
        this.handleTrackCustomEvent(
          "cbz_yjjc_index_js",
          "cbz_yjjc_index_js_click"
        );
        this.linkResultPage();
      }
    },
    closeDialog() {
      this.handleTrackCustomEvent(
        "cbz_yjjc_index_tc_close",
        "cbz_yjjc_index_tc_close_click"
      );
      this.dialogShow = false;
    },
    // 跳转中奖结果页
    linkResultPage(type) {
      if (type === "awardEntry") {
        this.handleTrackCustomEvent(
          "cbz_yjjc_index_zjjg",
          "cbz_yjjc_index_zjjg_click"
        );
      }
      let params = {
        code: this.activityCode || Tool.getUrlParam().code || "",
      };
      let isLocalEnv = window.location.origin.includes(
        "http://t.yczj.m.autohome.com.cn"
      );
      let linkUrl = `${window.location.origin}${
        isLocalEnv ? "" : "/topic/guessing-competition"
      }/result?code=${this.activityCode || Tool.getUrlParam().code || ""}`;
      Common.pageJumpHandel(linkUrl, params);
    },
    // 竞猜弹窗确认
    confirmHandel() {
      this.handleTrackCustomEvent(
        "cbz_yjjc_index_tc_ok",
        "cbz_yjjc_index_tc_ok_click"
      );
      if (!this.inputPrice) {
        this.$toast("请填写竞猜价格");
        return;
      } else if (!/^([1-9]\d*|0)(\.\d{1,4})?$/.test(this.inputPrice)) {
        this.$toast("请输入不超过四位小数的正确数值");
      } else {
        this.dialogShow = false;
        this.guessPrice = this.inputPrice;
        // 竞猜接口
        Api.getGuess({
          code: this.activityCode || Tool.getUrlParam().code || "",
          price: this.inputPrice,
        })
          .then((res) => {
            let key = "";
            if (res.returncode === 0) {
              this.inputPrice = "";
              // 修改用户参与活动状态
              this.btnTextStatus = 2;
              this.lastId = 0;
              this.hasMore = true;
              this.guessList = [];
              this.getUserList(1);
              key = res.result.key;
              this.guessResultMsg = key && this.activitySetting[`${key}`];
              this.confirmDialogShow = true;
            } else if (res.returncode === 1) {
              this.inputPrice = "";
              this.$toast(res.message || "竞猜失败，请稍后重试");
            }
            this.getActivitySetting("reload");
          })
          .catch((err) => {
            this.inputPrice = "";
            this.$toast("当前无网络，请稍后重试");
            console.log(err, "竞猜接口报错了");
          });
      }
    },
    // 输入框input事件
    inputChangeHandel(e) {
      this.inputPrice = e.target.value.replace(/[^\d.]/g, "").substring(0, 8);

      console.log(this.inputPrice);
    },
    onBlur() {
      window.scrollTo(0, 0);
    },

    // 微信二次分享设置
    setWeiXinShare(isHandle, mdtype) {
      let shareTitle = `${this.activitySetting.shareTitle || "分享副标题"}`;
      let shareDesc = `${this.activitySetting.shareDesc || "分享副标题"}`;
      let shareImgUrl = `${(this.activitySetting.shareImgUrl &&
        JSON.parse(this.activitySetting.shareImgUrl)[0]) ||
        "https://x.autoimg.cn/cfw/yc/images/chezhu-logo.png"}`;
      let that = this;
      const isMainApp = Tool.webApp.uaIsAutohome(); //区分主软 车主版
      // const shareUrl = 'https://athm.cn/54KR82c'

      Utils.share({
        params: {
          shareTitle,
          shareDesc,
          shareUrl: window.location.href,
          shareImgUrl,
          isShareSame: false,
          success() {
            if (isHandle) {
              // 端内分享成功后获取竞猜机会
              that.activityInfo.status === 1 &&
                that.addActivityQualification("share");
              that.confirmDialogShow = false;
            }
          },
          fail() {},
        },
        isHandle,
      });
      if (isHandle) {
        this.handleTrackCustomEvent(
          "cbz_yjjc_index_share",
          "cbz_yjjc_index_share_click",
          { type: mdtype }
        );
      }
    },
    likeClick(item, index) {
      let fn = this.likeClickHandel(item, index);
      let t = this.throttle(fn, 2000);
      t();
    },
    // 点赞操作
    likeClickHandel(item, index) {
      this.likeClickIndex = index;
      this.likeClicked = false;
      if (item.liked === 1) {
        this.$toast("您已经点过赞了~");
        return;
      }
      Api.getLike({
        code: this.activityCode || Tool.getUrlParam().code || "",
        objId: item.id,
      })
        .then((res) => {
          if (res.returncode === 0) {
            this.likeClicked = true;
            item.liked = 1;
            item.likeCount++;
            this.$toast(res.message);
          }
        })
        .catch((error) => {
          this.$toast("当前无网络，请稍后重试");
          console.log(error, "点赞接口异常了-----");
        });
    },
    // 商品详情跳转地址
    viewAwardDetail(url) {
      this.handleTrackCustomEvent(
        "cbz_yjjc_index_bqjp",
        "cbz_yjjc_index_bqjp_click"
      );
      url && Common.pageJumpHandel(url, {});
    },
    viewBigImage(index) {
      this.activeIndex = index;
      this.startIndex = index - 1;
      this.bigImageShow = true;
    },
    onChange(index) {
      this.activeIndex = index + 1;
    },
    viewRules() {
      this.ruleTextShow = !this.ruleTextShow;
      this.handleTrackCustomEvent(
        "cbz_yjjc_index_rule",
        "cbz_yjjc_index_rule_click"
      );
    },
    // 输入框点击
    inputClick() {
      this.handleTrackCustomEvent(
        "cbz_yjjc_index_sz",
        "cbz_yjjc_index_sz_click"
      );
    },
    throttle(fn, delay) {
      let that = this;
      return function() {
        let args = arguments;
        clearTimeout(that.timer);
        that.timer = setTimeout(() => {
          fn.apply(that, args);
        }, delay);
      };
    },
    // 点击统计
    handleTrackCustomEvent(page, action, extendParams = {}) {
      // eslint-disable-next-line
      trackCustomEvent(
        "yc_page_common_click",
        {
          bus: "1",
          page: page,
          refpage: Tool.getCookie("refpage") || "",
          channel: Tool.getCookie("channel") || "",
          city: Tool.getCookie("cityId") || 110100,
          action: action,
        },
        {
          userId: Tool.getCookie("app_userid") || "",
          refpage_feed: Tool.getCookie("refpageFeed") || "",
          pvareaid: Tool.getUrlParam().pvareaid || "",
          ...extendParams,
        }
      );
    },
  },
};
</script>
<style lang="scss">
@import "../assets/style/pages/index.scss";
</style>
